import { Text } from '@user-portal/wikr-components';
import React from 'react';
import { Trans } from 'react-i18next';

import { getSubscriptionTitle } from '../../helpers';
import { SubRow } from '../../types';

import * as S from '../styled';

const PeriodRow = ({ period, isTrial, color }: SubRow) => {
    const paymentLabel = getSubscriptionTitle(period, false);

    return (
        <S.SubscriptionCardRow>
            <Text type="large-text" color={color} medium dataLocator="subscriptionPeriod">
                <Trans
                    i18nKey={isTrial ? 'subscription.period.trial' : 'subscription.period.regular'}
                    values={{
                        count: paymentLabel?.count,
                        context: paymentLabel?.context,
                    }}
                />
            </Text>
        </S.SubscriptionCardRow>
    );
};

export default PeriodRow;
